"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyDisplay;
(function (CurrencyDisplay) {
    CurrencyDisplay[CurrencyDisplay["Symbol"] = 0] = "Symbol";
    CurrencyDisplay[CurrencyDisplay["Code"] = 1] = "Code";
    /** @deprecated MSPA should be using normal web/desktop currency display */
    CurrencyDisplay[CurrencyDisplay["AppSymbol"] = 2] = "AppSymbol";
})(CurrencyDisplay = exports.CurrencyDisplay || (exports.CurrencyDisplay = {}));
;
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["code"] = "code";
    CurrencyType["symbol"] = "symbol";
})(CurrencyType = exports.CurrencyType || (exports.CurrencyType = {}));
;
var CurrencyLocation;
(function (CurrencyLocation) {
    CurrencyLocation["pre"] = "pre";
    CurrencyLocation["preSpace"] = "preSpace";
    CurrencyLocation["post"] = "post";
    CurrencyLocation["postSpace"] = "postSpace";
})(CurrencyLocation = exports.CurrencyLocation || (exports.CurrencyLocation = {}));
var NegativeSignLocation;
(function (NegativeSignLocation) {
    NegativeSignLocation["withNumber"] = "withNumber";
    NegativeSignLocation["withCurrency"] = "withCurrency";
    NegativeSignLocation["afterNumber"] = "afterNumber";
})(NegativeSignLocation = exports.NegativeSignLocation || (exports.NegativeSignLocation = {}));
//# sourceMappingURL=types.js.map